import React from 'react';
import PropTypes from 'prop-types';
import Component from "../../components/Component";
import ScrollArea from "react-scrollbar";

class ServiceDeliverables extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            tab: TB.first(props.phases || []),
            hideTabs: props.hideTabs,
            serviceId: props.serviceId
        }
    }

    hasChangedService()
    {
        return this.props.serviceId !== this.state.serviceId
    }

    activePhase()
    {
        if (this.hasChangedService()) {
            return TB.first(this.props.phases)
        }
        return TB.find(this.props.phases, ['id', this.state.tab.id])
    }

    render()
    {
        let {
            tab
        } = this.state;
        let {phases, serviceId, scrollable} = this.props;

        return (
            <div className="pyo-tab-details">
                <div className={TB.mapClass('detail-tabs', {
                    'grid-cols-4': phases.length >= 4,
                    'grid-cols-3': phases.length < 4,
                })}>
                    {phases.map((phase, phaseIndex) => {
                        return (
                            <button
                                key={phase.id}
                                type="button"
                                onClick={() => this.setState({ tab: phase, serviceId })}
                                className={this.activePhase().id === phase.id ? "active" : ""}
                            >
                                <h5 className="text-xxs pb-1">Phase {phaseIndex + 1}</h5>
                                <p>{phase.name}</p>
                            </button>
                        )
                    })}
                </div>
                <div className="pyo-detail-table">

                    {scrollable ? (
                            <ScrollArea
                                speed={0.8}
                                className="area"
                                smoothScrolling={true}
                                contentClassName="scroll-area"
                                stopScrollPropagation={true}
                                horizontal={false}>

                                <div className="mx-3">{this.renderTable()}</div>
                            </ScrollArea>
                        ) : this.renderTable()
                    }
                </div>
            </div>
        );
    }

    renderTable() {
        let {
            tab
        } = this.state;
        let {phases} = this.props;

        return (
            <div className="w-full flex flex-col divide-y items-stretch">
                {tab && phases.length > 0 &&
                    this.activePhase().deliverables.map((deliverable, dIndex) => (
                    <div key={'deliverable' + deliverable.id} className="py-4">
                        <div className="border-black border px-6 py-2 h-20 flex flex-row divide-x items-stretch gap-4">
                            <div className="basis-1/3 px-3 flex flex-col justify-center items-center">
                                <p className="text-xs font-semibold text-center">
                                    {deliverable.name}
                                </p>
                            </div>
                            <div className="basis-2/3 px-3 flex flex-col justify-center items-center">

                            <p className="text-xs text-center">
                                {deliverable.description}
                            </p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        )
    }
    // renderTable() {
    //     let {
    //         tab
    //     } = this.state;
    //     let {phases} = this.props;
    //
    //     return (
    //         <table className="w-full">
    //             <tbody>
    //             {
    //                 tab && phases.length > 0 &&
    //                 this.activePhase().deliverables.map((deliverable, dIndex) => (
    //                     <tr key={'deliverable' + deliverable.id} className={"pyo-detail-table-row"}>
    //                         <td>
    //                             <p>
    //                                 {dIndex + 1}. {deliverable.name}
    //                             </p>
    //                         </td>
    //                         <td>
    //                             <p>
    //                                 {deliverable.description}
    //                             </p>
    //                         </td>
    //                     </tr>
    //                 ))
    //             }
    //             </tbody>
    //         </table>
    //     )
    // }
}

ServiceDeliverables.propTypes = {
    phases: PropTypes.any,
    scrollable: PropTypes.bool
};

export default ServiceDeliverables;